<template>
    <div class="background pa-4">
        <div class="text--text font-weight-bold">{{ etiqueta }}</div>
        <div class="grey--text font-weight-medium text-body-1">{{ dato }}</div>
    </div>
</template>

<script>
export default {
    props: {
        etiqueta: String,
        dato: String,
    },
};
</script>
